import React from "react";

interface Props {
    title: string
    html: string
}

interface State {
    open: boolean

}

export class QandAsegment extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)
        this.state = { open: false }
    }

    onHeaderClicked = () => {
        this.setState({ open: !this.state.open })
    }
   
    render() {
        const { open } = this.state
        return (
            <div>
                {/* <Link key={faq.node.id} to={faq.node.frontmatter.path}> </Link> */}
                <h2 onClick={this.onHeaderClicked}
                    style={{ fontSize: "1.5em", cursor: "pointer" }}
                >
                    <i className={`fa fa-chevron-${open ? 'down' : 'right'}`} style={{ marginRight: "0.5em" }} />
                    {' '}
                    {this.props.title}
                </h2>
                { open &&
                    <div>
                        <div
                            style={{ marginLeft: "2em" }}
                            dangerouslySetInnerHTML={{ __html: this.props.html }}
                        />
                    </div>
                }
                <div onClick={open ? undefined : this.onHeaderClicked}>
                    <br />
                    <br />
                </div>
            </div>
        )
    }
}